import React from 'react';
import { Field } from 'react-final-form';
import { getNumericChars } from '../../../utils/helper';

function setNumberToInput(e, input, name, callback) {
    const val = getNumericChars(e.target.value);
    input.onChange(val);
    if (typeof callback === 'function') {
        callback(name, val);
    }
}

function onSelect(e, input, name, callback) {
    const val = e.target.value;
    input.onChange(val);
    if (typeof callback === 'function') {
        callback(name, val);
    }
}

export function deserialize(type, prescription) {
    if (prescription) {
        return Object.keys(prescription).reduce((m, key) => {
            if (key !== 'boxes') {
                m[`${key}-${type}`] = prescription[key];
            }
            return m;
        }, {});
    }
    return {};
}

export function getPrescription(prescription, whichEye) {
    const l = whichEye !== 'right' ? deserialize('left', prescription.left) : {};
    const r = whichEye !== 'left' ? deserialize('right', prescription.right) : {};
    return { ...l, ...r };
}

export function getDirtyValues(pristine, formValues) {
    if (formValues) {
        return Object.keys(formValues).reduce((memo, key) => {
            if (pristine[key] !== formValues[key]) {
                memo[key] = formValues[key];
            }
            return memo;
        }, {});
    }
}

export function getSubmitValues(dirtyValues, powers) {
    if (dirtyValues) {
        return Object.keys(dirtyValues).reduce((memo, key) => {
            const [type, eyeLR] = key.split('-');
            powers.reduce((memo, power) => {
                if (power.type === type) {
                    memo.push({ type, eyeLR, name: key, label: `${eyeLR} ${power.label}`, value: dirtyValues[key] });
                }
                return memo;
            }, memo);
            return memo;
        }, []);
    }
    return [];
}

export const FieldInput = ({ name, onChange }) => (
    <Field name={name}>
        {({ input }) => (<div className="mr-t5 inline-block"><input {...input} className="form-control" type="tel" onChange={e => setNumberToInput(e, input, name, onChange)} autoComplete="off" maxLength="3" /></div>)}
    </Field>
);

export const DropdownInput = ({ pleaseSelect, name, onChange, options, disable }) => (
    <Field name={name}>
        {({ input }) => (<select {...input} disabled={disable} className="form-control" onChange={e => { onSelect(e, input, name, onChange); }}>
            <option value="">--{pleaseSelect}--</option>
            {options.map((opt, i) => <option key={opt + '-' + i} value={opt}>{opt}</option>)}
        </select>)}
    </Field>
);

export const PowerInputs = ({ dataLocale, powers, whichEye, onSelect, onChange, values, isBifocal }) => {
    const { FITTING_HEIGHT_IS_REQUIRED, RIGHT, LEFT, PLEASE_SELECT } = dataLocale;
    return (
        <div>
            {powers.map(power => {
                let msg;
                if (power.type === 'boxes') return null;
                const options = power.powerDataList && power.powerDataList[0] && power.powerDataList[0].value;
                let disable = false;
                if (isBifocal && ['lensHeight', 'lensWidth'].indexOf(power.type) >= 0) {
                    disable = values && !values['bottomDistance-left'];
                    msg = FITTING_HEIGHT_IS_REQUIRED;
                }
                return {
                    drop_down: (
                        <React.Fragment key={power.type}>
                            <div className="form-group-container">
                                {whichEye !== 'left' && <div className="form-group">
                                    <label className="padding-r10 text-capitalize">{RIGHT} {power.label}</label>
                                    <DropdownInput pleaseSelect={PLEASE_SELECT} name={`${power.type}-right`} options={options} onChange={onSelect} disable={disable} />
                                </div>}
                                {whichEye !== 'right' && <div className="form-group">
                                    <label className="padding-r10 text-capitalize">{LEFT} {power.label}</label>
                                    <DropdownInput pleaseSelect={PLEASE_SELECT} name={`${power.type}-left`} options={options} onChange={onSelect} disable={disable} />
                                </div>}
                            </div>
                            {disable && <div style={{ color: '#cc0000', fontSize: '10px', marginBottom: '7px' }}>{msg}</div>}
                        </React.Fragment>
                    ),
                    field: (
                        <div className="form-group-container" key={power.type}>
                            {whichEye !== 'left' && <div className="form-group">
                                <label className="padding-r10 text-capitalize">{RIGHT} {power.label}</label>
                                <FieldInput name={`${power.type}-right`} onChange={onChange} />
                            </div>}
                            {whichEye !== 'right' && <div className="form-group">
                                <label className="padding-r10 text-capitalize">{LEFT} {power.label}</label>
                                <FieldInput name={`${power.type}-left`} onChange={onChange} />
                            </div>}
                        </div>
                    )
                }[power.inputType];
            })}
        </div>
    );
};
